import React from 'react';
import { LocationIcon, MessageChatCircle, MessageSmileCircle, PhoneIcon } from '../../icons';

const Contact = () => {
  return (
    <div className='flex items-center justify-center w-full flex-col'>
      {/* Banner Section */}
      <div className="flex flex-col gap-[24px] px-[4vw] py-[64px] max-w-[1980px] w-full">
        <div className="flex flex-col">
          <span className='text-[#1C9943] font-[600]'>Get in Touch</span>
          <h2 className='text-[#101828] text-[48px] max-lg:text-[40px] max-md:text-[36px] max-sm:text-[32px] font-[600]'>
            We are here to help you
          </h2>
        </div>
        <p className='text-[#475467] '>Feel free to reach out to us through any of the following methods.</p>
      </div>

      {/* Contact Cards */}
      <div className="grid grid-cols-4 gap-[24px] px-[4vw] py-[64px] max-xl:grid-cols-3 max-lg:grid-cols-2 max-sm:grid-cols-1 max-w-[1980px] w-full">
        <div className="bg-[#F9FAFB] flex flex-col gap-[64px] p-[24px] rounded-[10px] items-start">
          <div className="flex items-center justify-center rounded-xl p-[12px] bg-[#1C9943] w-fit">
            <MessageSmileCircle className="w-[24px] h-[24px]" />
          </div>
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col gap-[8px]">
              <span className="text-[#101828] text-[20px] font-[600]">Contact Support</span>
              <span className="text-[#475467] text-[16px] font-[400]">Speak to our team</span>
            </div>
            <a target='_blank' href='mailto:contact@fiindustries.com' rel="noreferrer" className="text-[#5556C3] font-[600]"> Letstalk@healtharchitect.co.uk</a>
          </div>
        </div>
        <div className="bg-[#F9FAFB] flex flex-col gap-[64px] p-[24px] rounded-[10px] items-start">
          <div className="flex items-center justify-center rounded-xl p-[12px] bg-[#1C9943] w-fit">
            <MessageChatCircle iconColor={'#fff'} className="w-[24px] h-[24px]" />
          </div>
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col gap-[8px]">
              <span className="text-[#101828] text-[20px] font-[600]">Chat Support</span>
              <span className="text-[#475467] text-[16px] font-[400]">We are here to help</span>
            </div>
            <a target='_blank' href='mailto:info@fiindustries.com' rel="noreferrer" className="text-[#5556C3] font-[600]">Support@healtharchitect.co.uk</a>
          </div>
        </div>
        <div className="bg-[#F9FAFB] flex flex-col gap-[64px] p-[24px] rounded-[10px] items-start">
          <div className="flex items-center justify-center rounded-xl p-[12px] bg-[#1C9943] w-fit">
            <LocationIcon className="w-[24px] h-[24px]" />
          </div>
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col gap-[8px]">
              <span className="text-[#101828] text-[20px] font-[600]">Visit us</span>
              <span className="text-[#475467] text-[16px] font-[400]">Visit our clinic.</span>
            </div>
            <span className="text-[#5556C3] font-[600]">Piccadilly, Manchester City Centre</span>
          </div>
        </div>
        <div className="bg-[#F9FAFB] flex flex-col gap-[64px] p-[24px] rounded-[10px] items-start">
          <div className="flex items-center justify-center rounded-xl p-[12px] bg-[#1C9943] w-fit">
            <PhoneIcon className="w-[24px] h-[24px]" />
          </div>
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col gap-[8px]">
              <span className="text-[#101828] text-[20px] font-[600]">Call us</span>
              <span className="text-[#475467] text-[16px] font-[400]">Mon-Fri from 8am to 5pm.</span>
            </div>
            <a target='_blank' href='tel:+966560008380' rel="noreferrer" className="text-[#5556C3] font-[600]">+44 7400242044</a>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="flex flex-col max-w-[1980px] w-full">
        <div className="flex items-end justify-between gap-[24px] max-sm:flex-col w-full bg-[#F9FAFB] px-[4vw] py-[64px] pb-[160px]">
          <div className="flex flex-col gap-[24px] w-full">
            <div className="flex flex-col gap-[24px]">
              <span className='text-[#1C9943] font-[600]'>Our Office</span>
              <h2 className='text-[#101828] text-[36px] max-sm:text-[24px] font-[600]'>Our locations</h2>
            </div>
            <p className='text-[#475467] text-[20px]'>Come visit our friendly team at one of our offices.</p>
          </div>
          <div className="flex flex-col gap-[32px] max-sm:w-full">
            <div className="flex items-center gap-[10px] sm:min-w-[560px] max-sm:min-w-[100%] max-lg:w-full">
              <div className="flex items-center justify-center rounded-xl p-[12px] bg-[#1C9943] w-fit">
                <LocationIcon className="w-[24px] h-[24px]" />
              </div>
              <div className="flex flex-col gap-[4px]">
                <span className='text-[#101828] text-[18px] font-[600]'>M1 1JG</span>
                <span className='text-[#475467] font-[400]'>Oldham St, Manchester, UK</span>
              </div>
            </div>
            <div className="flex items-center gap-[10px] sm:min-w-[560px] max-sm:min-w-[100%] max-lg:w-full">
              <div className="flex items-center justify-center rounded-xl p-[12px] bg-[#1C9943] w-fit">
                <LocationIcon className="w-[24px] h-[24px]" />
              </div>
              <div className="flex flex-col gap-[4px]">
                <span className='text-[#101828] text-[18px] font-[600]'>London</span>
                <span className='text-[#475467] font-[400]'>100 George Street, London NSW 2000 Uk</span>
              </div>
            </div>
          </div>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d463877.31242688524!2d46.49288432992219!3d24.725455373149728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f03890d489399%3A0xba974d1c98e79fd5!2sRiyadh%20Saudi%20Arabia!5e0!3m2!1sen!2s!4v1711974281732!5m2!1sen!2s"
          className=' w-full rounded-[10px] outline-none overflow-hidden px-[4vw] pb-[64px] -translate-y-[96px]'
          height={660}
          style={{ border: 0 }}
          allowFullScreen=""
          title="map"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      {/* Contact Form Section */}
      <div className="flex flex-col items-center gap-[64px] px-[4vw] py-[64px] max-w-[1980px] w-full">
        <div className="flex flex-col gap-[0px] items-center">
          <span className='text-[#1C9943] font-[600]'>Contact Us</span>
          <h1 className='text-[#101828] text-[32px] max-sm:text-[24px] font-[600]'>Send us a Message</h1>
          <p className='text-[#475467] mt-[12px]'>We would love to hear from you. Please fill out the form below.</p>
        </div>
        <div className="grid grid-cols-2 gap-[32px] max-sm:gap-[16px] max-sm:flex max-sm:flex-col max-sm:w-full">
          <div className={` flex flex-col gap-[6px] w-full`}>
            <label htmlFor="" className='text-[14px] text-[#344054]'>
              First name
            </label>
            <input type={'text'} placeholder={'First name'} style={{ border: '1px solid #D0D5DD' }} value={''} className=' w-full placeholder:text-[#667085] text-[#667085] p-[10px] px-[14px] outline-none rounded-[8px]' />
          </div>
          <div className={` flex flex-col gap-[6px] w-full`}>

            <label htmlFor="" className='text-[14px] text-[#344054]'>
              Last name
            </label>

            <input type={'text'} placeholder={'Last name'} style={{ border: '1px solid #D0D5DD' }} value={''} className=' w-full placeholder:text-[#667085] text-[#667085] p-[10px] px-[14px] outline-none rounded-[8px]' />

          </div>
          <div className={` flex flex-col gap-[6px] w-full col-span-2`}>

            <label htmlFor="" className='text-[14px] text-[#344054]'>
              Email
            </label>

            <input type={'email'} placeholder={'you@company.com'} style={{ border: '1px solid #D0D5DD' }} value={''} className=' w-full placeholder:text-[#667085] text-[#667085] p-[10px] px-[14px] outline-none rounded-[8px]' />

          </div>
          <div className={` flex flex-col gap-[6px] w-full col-span-2`}>

            <label htmlFor="" className='text-[14px] text-[#344054]'>
              Phone number
            </label>

            <input type={'number'} placeholder={'+44 46 3442 12987'} style={{ border: '1px solid #D0D5DD' }} value={''} className=' w-full placeholder:text-[#667085] text-[#667085] p-[10px] px-[14px] outline-none rounded-[8px]' />

          </div>
          <div className="flex flex-col gap-[6px] w-full col-span-2">
            <label htmlFor="" className='text-[14px] text-[#344054]'>Message</label>
            <textarea
              style={{ border: '1px solid #D0D5DD' }}
              cols="30"
              rows="10"
              placeholder='Your message here...'
              className='w-full placeholder:text-[#667085] text-[#667085] p-[10px] px-[14px] outline-none rounded-[8px] resize-none'
            ></textarea>
          </div>
          <div className="flex items-center gap-[12px] col-span-2">
            <input id='privacyPolicy' type="checkbox" className='w-[20px] h-[20px]' />
            <label htmlFor='privacyPolicy' className='text-[#475467]'>You agree to our friendly privacy policy.</label>
          </div>
          <button className='flex items-center gap-[24px] px-[24px] py-[12px] bg-[#1C9943] text-[#fff] rounded-[8px] w-full col-span-2 text-center justify-center mt-[16px]'>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default Contact;
